
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter, State } from 'vuex-class';
import TopToolbar from '~/components/Home/TopToolbar.vue';
import { IProfileState } from '~/store/profile/types';
import { TSiteConfigState } from '~/store/types';

@Component({
  components: {
    TopToolbar,
  },
})
export default class DashboardHeader extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly showWalletPrompt!: boolean;
  @Prop(Number) readonly systemBarHeight!: number;
  @Prop(Number) readonly toolbarHeight!: number;
  @Prop(Boolean) readonly uaPage!: boolean;
  @Prop(Boolean) readonly thankYouPage!: boolean;

  @State((profile: IProfileState) => profile.user.loggedIn, {
    namespace: 'profile',
  })
  loggedIn!: boolean;
  @State((profile: IProfileState) => !!profile.user.discordProfile, {
    namespace: 'profile',
  })
  discordConnected!: boolean;
  @State((share) => share.nodesOwned, { namespace: 'share' })
  readonly nodesOwned!: number;

  @Action('getUserNodes', { namespace: 'nodes' })
  private getUserNodes!: () => void;

  @Getter('siteConfig')
  readonly siteConfigState!: TSiteConfigState;

  get siteConfig() {
    return this.$sanityLookup.getSiteConfig()?.data;
  }

  get tabs() {
    return this.siteConfigState.isLoading
      ? []
      : [
          {
            title: 'Nodes',
            name: this.$t('common.navigation.nodes') as string,
            to: '/nodes',
            requirement: true,
          },
          {
            icon: '$vuetify.icons.inventory',
            title: 'Inventory',
            name: this.$t('common.misc.myCollection') as string,
            to: '/my-collection',
            requirement: this.loggedIn,
          },
        ].filter((tab) => {
          return tab.requirement;
        });
  }

  created() {
    this.getUserNodes();
  }

  get isMarketingMode() {
    return this.siteConfig?.isMarketingMode;
  }

  get isDesktopView() {
    return this.discordConnected
      ? this.$vuetify.breakpoint.width > 1035
      : this.$vuetify.breakpoint.width > 1100;
  }
}
